export const PLAYER_AUTO_HIDE_CONTROLS_TIMEOUT_IN_MS = 5000;

export const SEEKBAR_STEP_TIME_IN_MS = 15000;
